import { render, staticRenderFns } from "./AudioElement.vue?vue&type=template&id=1de205b9&scoped=true&"
import script from "./AudioElement.vue?vue&type=script&lang=ts&"
export * from "./AudioElement.vue?vue&type=script&lang=ts&"
import style0 from "./AudioElement.vue?vue&type=style&index=0&id=1de205b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de205b9",
  null
  
)

export default component.exports